class DiscountCopyButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button') || this.querySelector('.js-copy-discount') || this;
    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(e) {
    const code = this.button.dataset.textToCopy || this.dataset.textToCopy;
    if (!code) return;

    navigator.clipboard.writeText(code).then(() => {
      this.button.classList.remove('is-applied');
      this.button.classList.add('is-copied');
      
      setTimeout(() => {
        this.button.classList.remove('is-copied');
        this.button.classList.add('is-applied');
      }, 2000);

      this.showToast(
        code,
        this.button.dataset.toastMessage || this.dataset.toastMessage || 'Apply it in your cart to get a discount.',
        this.button.dataset.successColor || this.dataset.successColor || '#57ffa7'
      );
    });
  }

  showToast(code, message, color) {
    let toastEl = document.querySelector('.js-discount-toast');
    
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'discount-toast js-discount-toast';
      toastEl.setAttribute('role', 'alert');
      toastEl.innerHTML = `
        <div class="discount-toast__content">
          <svg class="discount-toast__icon" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/>
            <path d="M6 10L9 13L14 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <p class="discount-toast__text"></p>
        </div>
        <button class="discount-toast__close js-toast-close" aria-label="Close">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      `;
      document.body.appendChild(toastEl);

      toastEl.querySelector('.js-toast-close').addEventListener('click', () => {
        toastEl.classList.remove('is-visible');
        if (window.discountToastTimeout) clearTimeout(window.discountToastTimeout);
      });
    }

    toastEl.style.setProperty('--discount-success-color', color);
    toastEl.querySelector('.discount-toast__text').innerHTML = `<strong>${code} copied!</strong> ${message}`;
    toastEl.classList.add('is-visible');

    if (window.discountToastTimeout) clearTimeout(window.discountToastTimeout);
    window.discountToastTimeout = setTimeout(() => {
      toastEl.classList.remove('is-visible');
    }, 2000);
  }
}

if (!customElements.get('discount-copy-button')) {
  customElements.define('discount-copy-button', DiscountCopyButton);
}
